var angular = require('angular');
var PortalAPI = require('../api').Portal;
var Promise = require('bluebird');

module.exports = ForgotPasswordController;

function ForgotPasswordController($scope, $stateParams) {
  $scope.user = {};
  $scope.buttonMessage = "Reset Password";

  $scope.submit = function(){
    var user = $scope.user;
    $scope.waitingOnServer = true;
    $scope.buttonMessage = "Sending reset link";

    return PortalAPI
      .forgotPassword({
        email: user.email
      })
      .then(function(resp){
        $scope.buttonMessage = "Reset Password";
        $scope.waitingOnServer = false;
        $scope.error = null;
        $scope.success = true;
      })
      .catch(function(resp){
        $scope.buttonMessage = "Reset Password";
        $scope.waitingOnServer = false;
        $scope.error = resp.body.error;
      })
  }

}
